import { render, staticRenderFns } from "./deliveryPage.vue?vue&type=template&id=579ee67e&"
import script from "./deliveryPage.vue?vue&type=script&lang=js&"
export * from "./deliveryPage.vue?vue&type=script&lang=js&"
import style0 from "./deliveryPage.vue?vue&type=style&index=0&id=579ee67e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports